const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const ScaredCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'scared';

	const extant = BattleCalc.getCondition( owner, 'scared' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = ScaredCondition
